import { render, staticRenderFns } from "./policyDialog.vue?vue&type=template&id=601a499c&scoped=true&"
import script from "./policyDialog.vue?vue&type=script&lang=js&"
export * from "./policyDialog.vue?vue&type=script&lang=js&"
import style0 from "./policyDialog.vue?vue&type=style&index=0&id=601a499c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a499c",
  null
  
)

export default component.exports